import React from 'react';
import './Services.css';
import { FaCode, FaMobileAlt, FaPaintBrush, FaBullhorn, FaServer, FaShoppingCart } from 'react-icons/fa';
import { BsCheck2Circle } from 'react-icons/bs';

const Services = () => {
  const services = [
    {
      icon: <FaCode />,
      title: 'Web Development',
      description: 'Custom websites and web applications built with modern technologies like React, Node.js, and more.',
      features: ['Responsive Design', 'Fast Performance', 'SEO Optimized']
    },
    {
      icon: <FaMobileAlt />,
      title: 'Mobile Apps',
      description: 'Native and cross-platform mobile applications for iOS and Android with seamless user experience.',
      features: ['Native Performance', 'Cross-Platform', 'User Friendly']
    },
    {
      icon: <FaPaintBrush />,
      title: 'UI/UX Design',
      description: 'Beautiful and intuitive user interfaces that enhance user experience and engagement.',
      features: ['Modern Design', 'User Research', 'Prototyping']
    },
    {
      icon: <FaBullhorn />,
      title: 'Digital Marketing',
      description: 'Strategic digital marketing solutions to grow your online presence and reach target audience.',
      features: ['SEO/SEM', 'Social Media', 'Content Strategy']
    },
    {
      icon: <FaServer />,
      title: 'Backend Development',
      description: 'Robust and scalable backend systems with APIs, databases, and server management.',
      features: ['RESTful APIs', 'Database Design', 'Cloud Services']
    },
    {
      icon: <FaShoppingCart />,
      title: 'E-Commerce',
      description: 'Complete e-commerce solutions with payment integration, inventory management, and more.',
      features: ['Payment Gateway', 'Admin Panel', 'Order Management']
    }
  ];

  return (
    <section className="services" id="services">
      <div className="container">
        <div className="section-header">
          <h2>Our Services</h2>
          <p>What We Offer to Our Clients</p>
        </div>
        
        <div className="services-grid">
          {services.map((service, index) => (
            <div className="service-card" key={index}>
              <div className="service-icon">{service.icon}</div>
              <h3>{service.title}</h3>
              <p>{service.description}</p>
              <ul className="service-features">
                {service.features.map((feature, idx) => (
                  <li key={idx}>
                    <BsCheck2Circle className="check-icon" /> {feature}
                  </li>
                ))}
              </ul>
              <a href="#contact" className="service-link">Get Started →</a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
